import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import PageLayout from './components/PageLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProductionDetail from './pages/ProductionDetail';
import NewProduction from './pages/NewProduction';
import JobDetail from './pages/JobDetail';
import Voices from './pages/Voices';
import Avatars from './pages/Avatars';
import AdminLayout from './pages/admin/AdminLayout';
import ClientsList from './pages/admin/ClientsList';
import ClientDetail from './pages/admin/ClientDetail';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <PageLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="production/:id" element={<ProductionDetail />} />
        <Route path="productions/new" element={<NewProduction />} />
        <Route path="job/:id" element={<JobDetail />} />
        <Route path="voices" element={<Voices />} />
        <Route path="avatars" element={<Avatars />} />
      </Route>
      <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route index element={<ClientsList />} />
        <Route path="client/:id" element={<ClientDetail />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
